import React from 'react'
import Amplify from 'aws-amplify'
import { Provider } from 'react-redux'
import configureStore from 'store'
import rootSaga from 'store/sagas'
import Routes from './routes'
import configDev from '@wellbeingxltd/fe-lib/api/supplier/aws-exports-dev'
import configDemo from '@wellbeingxltd/fe-lib/api/supplier/aws-exports-demo'
import configStg from '@wellbeingxltd/fe-lib/api/supplier/aws-exports-stg'
import configPrd from '@wellbeingxltd/fe-lib/api/supplier/aws-exports-prd'
import { __ENV__ } from 'awsApi'

switch (__ENV__) {
    case 'DEV':
        Amplify.configure(configDev)
        break
    case 'DEMO':
        Amplify.configure(configDemo)
        break
    case 'STG':
        Amplify.configure(configStg)
        break
    case 'PRD':
        Amplify.configure(configPrd)
        break
    default:
        break
}

const store = configureStore()
store.runSaga(rootSaga)

function App() {
    return (
        <Provider store={store}>
            <Routes />
        </Provider>
    )
}

if (window.Cypress) {
    window.store = store
}

export default App
